import React, { lazy } from 'react';
import { RouterProps } from '../shared/types/route.type';
import AppComponents from '../views/AppComponents';
import { AppRoutes } from './routeConstants/appRoutes';
import AddUser from 'views/AddUser';
import Dashboard from 'views/Dashboard';
import PageNotFound from 'views/PageNotFound';
import PrivateRoute from 'shared/components/PrivateRoute';
import RoleProtectedRoute from 'shared/components/RoleProtectedRoute';
import CreateSupplier from 'views/CreateSupplier';
import AddLocation from 'views/AddLocations';
import EditOrganisationMap from 'views/CompanySetup/OrganisationMap/EditOrganisationMap';
import CompanyDashboard from 'views/CompanyDashboard';
import OrganisationDetailsPage from 'views/OrganisationDetails';
import TargetPage from 'views/Targets';
import PublicRoute from 'shared/components/PublicRoute';
import ValueChainList from 'views/ValueChainList';
import { Outlet } from 'react-router-dom';
import AccountsList from 'views/AccountsList';
import ApiReference from 'views/ApiReference';
import { hasAdminAccess } from 'shared/utils/roleUtils';

const UtilityDashboard = lazy(() => import('views/UtilityDashboard'));
const WasteDashboard = lazy(() => import('views/WasteDashboard'));


export const nonGroupingRoutes: RouterProps[] = [
  {
    path: AppRoutes.INCORRECT_ROUTE,
    element: (
      <PublicRoute>
        <PageNotFound />
      </PublicRoute>
    ),
    children: [],
  },
  {
    path: AppRoutes.APP_COMPONENTS,
    element: (
      <PublicRoute>
        <AppComponents />
      </PublicRoute>
    ),
    children: [],
  },
  {
    path: AppRoutes.API_REFERENCE,
    element: (
      <PublicRoute>
        <ApiReference />
      </PublicRoute>
    ),
    children: [],
  },
  {
    path: AppRoutes.COMPANY_DASHBOARD,
    element: <CompanyDashboard />,
  },
  {
    path: AppRoutes.UTILITY_DASHBOARD,
    element: (
      <PrivateRoute>
        <UtilityDashboard />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.WASTE_DASHBOARD,
    element: (
      <PrivateRoute>
        <WasteDashboard />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.ADD_LOCATIONS,
    element: (
      <PrivateRoute>
        <AddLocation />
      </PrivateRoute>
    ),
    children: [],
  },
  {
    path: AppRoutes.ADD_USER,
    element: (
      <PublicRoute>
        <AddUser />
      </PublicRoute>
    ),
    children: [],
  },
  {
    path: AppRoutes.CREATE_SUPPLIER,
    element: (
      <PrivateRoute>
        <CreateSupplier />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.DASHBOARD,
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.VALUE_CHAIN,
    element: (
      <PrivateRoute>
        <Outlet />
      </PrivateRoute>
    ),
    children: [
      {
        path: AppRoutes.PROCESSING_FACILITY,
        element: <ValueChainList />,
      },
      {
        path: AppRoutes.SUPPLIER,
        element: <ValueChainList />,
      },
    ],
  },
  {
    path: AppRoutes.ACCOUNTS,
    element: (
      <PrivateRoute>
        <RoleProtectedRoute hasAccess={hasAdminAccess}>
          <Outlet />
        </RoleProtectedRoute>
      </PrivateRoute>
    ),
    children: [
      {
        path: AppRoutes.USER_DETAILS,
        element: <AccountsList />,
      },
      {
        path: AppRoutes.PRICING,
        element: <AccountsList />,
      },
      {
        path: AppRoutes.API_KEYS,
        element: <AccountsList />,
      },
    ],
  },
  {
    path: AppRoutes.TARGETS,
    element: (
      <PrivateRoute>
        <TargetPage />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.EDIT_ORGANISATION_MAP,
    element: (
      <PrivateRoute>
        <EditOrganisationMap />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.ORGANISATION_DETAILS,
    element: (
      <PrivateRoute>
        <OrganisationDetailsPage />
      </PrivateRoute>
    ),
  },
];
